<template>
  <div
    class="preview-practice pa-4 rounded-lg bg-gray-0"
    data-qa="preview_practice"
  >
    <PracticeLogoBadge class="mb-1" />
    <h3 class="text-subtitle-1 mb-4">
      Врач чаще всего лечит
    </h3>

    <DiagramGender class="mb-4" />
    <DiagramAgeStacked class="mb-4" />

    <div class="position-relative mb-2">
      <DiseasesStatistics
        :limit="5"
        :show-code="false"
        compact
      />
      <div
        v-if="hasMoreDiseases"
        class="preview-practice__fade"
      />
    </div>

    <button
      type="button"
      class="d-flex align-center gc-1 pa-0 cursor-pointer preview-practice__more"
      data-qa="preview_practice_show_more"
      @click="$emit('click:show-more')"
    >
      <span class="text-body-2 primary--text">
        Смотреть все
      </span>
      <span class="ui-icon-arrow-right ui-icon-fz-medium primary--text" />
    </button>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useContextStore } from 'src/store'
import PracticeLogoBadge from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/PracticeLogoBadge.vue'
import DiagramGender from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/DiagramGender.vue'
import DiagramAgeStacked from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/DiagramAgeStacked.vue'
import DiseasesStatistics from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/DiseasesStatistics.vue'

const { context } = useContextStore()

defineEmits(['click:show-more'])

const hasMoreDiseases = computed(() => context.doctor_practice.mkb_practice.length > 5)
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.preview-practice {
  box-shadow: -1px 1px 11px 1px rgba(14, 39, 77, 0.13);

  &__fade {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 36px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, $ui-kit-bg-gray-0 100%);
    pointer-events: none;
  }

  &__more {
    border: 0;
    background: transparent;
  }
}
</style>
